<template>
  <div>
    <vue-headful title="Contact Details" />

    <v-layout row wrap>
      <v-flex xs12>
        <StepTitle>Contact Details</StepTitle>
      </v-flex>

      <v-flex xs12>
        <FormSectionTitle>Your Information</FormSectionTitle>
        <ContactDetailsBox v-if="currentPerson" :contact="currentPerson" editable />
        <BaseAlert
          v-else
          :hg-value="true"
          hg-type="warning"
          id="no-user-error">
          Sorry, we couldn't find a User with that info
        </BaseAlert>
      </v-flex>

      <v-flex xs12>
        <ContactSearch ref="contact-search" />
      </v-flex>

      <v-flex xs12>
        <ContactRole />
      </v-flex>
    </v-layout>
    <StepNavigation :continueDisabled="submitIsDisabled"/>
  </div>
</template>

<script>
import { Components, Constants } from '@homegauge/vue';
import { mapState } from 'vuex';

import FormSectionTitle from '@/components/FormSectionTitle.vue';
import StepNavigation from '@/components/StepNavigation.vue';
import ContactDetailsBox from '@/components/ContactDetailsBox.vue';
import ContactRole from '@/components/ContactRole.vue';
import ContactSearch from '@/components/ContactSearch.vue';
import StepTitle from '@/components/StepTitle.vue';
import RouteNameConstants from '@/router/constants/route-names';
import StepUtilities from '@/router/utilities/step-utilities';

const { BaseAlert } = Components;
const { AccountTypes } = Constants;

export default {
  components: {
    BaseAlert,
    ContactDetailsBox,
    ContactRole,
    ContactSearch,
    FormSectionTitle,
    StepNavigation,
    StepTitle,
  },
  data() {
    return {
      errorList: [],
      searched: false,
      email: '',
      foundUser: {},
      apiLoading: false,
      addContactClicked: false,
    };
  },
  computed: {
    ...mapState('Appointment', {
      appointmentContact: state => state.contactComponentData.contact,
    }),
    ...mapState('Auth', {
      currentPerson: state => state.person,
    }),
    submitIsDisabled() {
      return this.currentPerson.type === AccountTypes.REAL_ESTATE_PROFESSIONAL
        && !this.appointmentContact
        && this.$store.state.unleash.enabledFeatures['WEB-4892-Require-Customer-ScheduleNow'];
    },
  },
  mounted() {
    this.$store.commit('setStepIndex',
      StepUtilities.getStepIndexByRouteName(RouteNameConstants.AppointmentContact));
  },
};
</script>

<style lang="scss" scoped>
.add-person {
  padding-top: 20px;
}
</style>
